/**
 * Keeps an evaluation page's answers in request order. `start(background)`
 * returns `isCurrent()`, which turns false once a newer query starts or, for a
 * foreground query, once a newer foreground query starts. A slow answer then
 * cannot replace the results of a selection made since, and a background
 * reload started while a foreground query loads the same selection does not
 * drop the foreground answer that ends the loading state.
 */
export function createEvaluationQueryOrder() {
    let latest = 0;
    let latestForeground = 0;
    return {
        start(background = false) {
            const id = ++latest;
            if (!background) latestForeground = id;
            return () => id === (background ? latest : latestForeground);
        },
    };
}
